import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=fde5277e&scoped=true&lang=html"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=fde5277e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde5277e",
  null
  
)

export default component.exports